import {AlertOverviewType} from './api/types';

export class Storage {
    storage: {[key: string]: Array<AlertOverviewType>} = {};

    getRules(fromId: string, toId: string) {
        const key = `${fromId}_${toId}`;
        return this.storage[key];
    }

    setRules(fromId: string, toId: string, data: Array<AlertOverviewType>) {
        this.storage[`${fromId}_${toId}`] = data;
    }

    removeRules(fromId: string, toId: string) {
        const key = `${fromId}_${toId}`;
        delete this.storage[key];
    }

    removeSingleRule(fromId: string, toId: string, ruleNumber: string) {
        const key = `${fromId}_${toId}`;
        const rules = this.storage[key];

        if (rules) {
            this.storage[key] = rules.filter(rule => rule.alert !== ruleNumber);
        }
    }

    toggleActiveRule(fromId: string, toId: string, ruleNumber: string, isActive: boolean) {
        const key = `${fromId}_${toId}`;
        const rules = this.storage[key];
        if (rules) {
            this.storage[key] = rules.map(rule => {
                if (rule.alert === ruleNumber) {
                    return {...rule, isActive: isActive ? 'Y' : 'N'};
                }
                return rule;
            });
        }
    }
}

export class BPMRulesStorage {
    data: {[session: string]: Storage} = {};

    getStorage(session: string) {
        if (!this.data[session]) {
            // init new session storage
            this.data[session] = new Storage();
        }
        return this.data[session];
    }

    removeStorage(session: string) {
        delete this.data[session];
    }

    createStorage(session: string) {
        this.data[session] = new Storage();
        return this.data[session];
    }
}

export const bpmRulesStorage = new BPMRulesStorage();
